import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import durationPlugin from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(localizedFormat);
dayjs.extend(durationPlugin);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
});

export const generateTimeString = (_timestamp: number | string | Date) => {
  // 所有输入类型都转化为 Date 对象
  let dateObject;

  if (_timestamp instanceof Date) {
    dateObject = _timestamp;
  } else if (typeof _timestamp === 'string') {
    dateObject = new Date(_timestamp);
  } else {
    dateObject = new Date(_timestamp);
  }

  // 将 Date 对象转化为以毫秒为单位的数字 timestamp
  const timestamp = dateObject.getTime();

  const dayjsInstance = dayjs(timestamp);
  const isZh = dayjs.locale().startsWith('zh');

  let format = 'll LT'; // 其他年份：Jan 20, 2025 3:30 PM / 2025年1月20日 下午3:30

  if (dayjs().isSame(dayjsInstance, 'day')) {
    format = 'LT'; // 今天：3:30 PM / 下午3:30
  } else if (dayjs().subtract(1, 'day').isSame(dayjsInstance, 'day')) {
    format = isZh ? '[昨天] LT' : '[Yesterday] LT';
  } else if (dayjs().isSame(dayjsInstance, 'week')) {
    format = 'dddd LT'; // 本周：Monday 3:30 PM / 星期一 下午3:30
  } else if (dayjs().isSame(dayjsInstance, 'year')) {
    // 今年：dayjs 没有只显示月日的本地化格式，需要手动指定
    format = isZh ? 'M月D日 LT' : 'M/D LT';
  }

  return dayjsInstance.format(format);
};

export function formatDuration(durationInMs: any) {
  const durationObj = dayjs.duration(durationInMs, 'ms');
  const hours = durationObj.hours();

  // 如果 duration 超过一小时，则格式化为 HH:mm:ss
  // 否则格式化为 mm:ss
  if (hours > 0) {
    return durationObj.format('HH:mm:ss');
  }

  return durationObj.format('mm:ss');
}

export function formatDurationV2(durationInMs: any) {
  const durationObj = dayjs.duration(durationInMs, 'ms');
  const hours = durationObj.hours();

  if (hours > 0) {
    return durationObj.format('HH:mm:ss');
  }

  // 格式为1'28"
  const minutes = durationObj.minutes();
  const seconds = durationObj.seconds();

  return `${minutes}'${seconds}"`;
}

export const generateWeekDayDate = (_timestamp: number | string | Date) => {
  let dateObject;

  if (_timestamp instanceof Date) {
    dateObject = _timestamp;
  } else if (typeof _timestamp === 'string') {
    dateObject = new Date(_timestamp);
  } else {
    dateObject = new Date(_timestamp);
  }

  const timestamp = dateObject.getTime();

  const dayjsInstance = dayjs(timestamp);

  const format = 'dddd, MMM D';

  return dayjsInstance.format(format);
};
